import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { EngageActionPlan } from '../../types/EngageActionPlan';
import {
    requestEngageActionPlan,
    requestPauseActionPlan,
    requestResumeActionPlan,
    requestTimelineActionPlan,
} from '../engageActionPlan/engageActionPlan';

export function useEngageActionPlan(contactId: number) {
    return useQuery({
        queryKey: [`contact-${contactId}`, 'actionplans'],
        enabled: !!contactId,
        queryFn: async ({ signal }) => (await requestEngageActionPlan(contactId!, signal))?.data,
    });
}

export function usePauseEngageActionPlan(contactId: number) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (payload: EngageActionPlan) =>
            (await requestPauseActionPlan(payload, contactId)).data,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [`contact-${contactId}`, 'actionplans'] });
        },
    });
}

export function useResumeEngageActionPlan(contactId: number) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (payload: EngageActionPlan) =>
            (await requestResumeActionPlan(payload, contactId)).data,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [`contact-${contactId}`, 'actionplans'] });
        },
    });
}

export function useTimelineActionPlan(contactId: number, planId: number | undefined) {
    return useQuery({
        queryKey: [`contact-${contactId}`, 'actionplans', `timeline-${planId}`],
        // enabled: !!contactId && !!planId,
        queryFn: async ({ signal }) =>
            (await requestTimelineActionPlan(planId!, contactId, signal))?.data,
    });
}
